import {
  lesson5Assignment1,
  lesson5Assignment2
} from './assignments'
import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_5/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },

  {
    id: 1,
    previous: 0,
    next: 2,
    text: {
      data: 'You have only 2 moves.',
      position: 'left',
      styleClass: 'sm',
      timeout: 8000
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the correct <br/>Bishop and drag <br/>him to show the <br/>two moves to get <br/>the Bishop to a8.`,
      timeout: 7000
    },
    audio: { src: 'img/audio/lesson_5/1.mp3', start: true, controls: false },
    chessboard: {
      board: lesson5Assignment1({
        showIndicators: { allSides: true },
        position: '8/8/8/8/8/8/8/2B2B2',
        resultFen: 'B7/8/8/8/8/8/8/2B5',
        assignmentClass: 'custom-sparepiece show-center',
        next: 2
      }),
      positionFen: '8/8/8/8/8/8/8/2B2B2 w - - 0 1',
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_5/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    text: {
      data: 'Capture the Knight last!',
      position: 'left',
      styleClass: 'sm',
      timeout: 16000
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the Bishop, <br/>then drag him to the <br/>pawn you want him <br/>to capture. <br/>Remember, it has to <br/>be in  a straight <br/>diagonal line with <br/>the Bishop.`,
      timeout: 15000
    },
    audio: { src: 'img/audio/lesson_5/2.mp3', start: true, controls: false },
    chessboard: {
      board: lesson5Assignment2({
        showIndicators: { allSides: true },
        position: '8/1p3p2/p5p1/8/2p1p3/1p6/8/3n1B2',
        resultFen: '8/8/8/8/8/8/8/3B4',
        assignmentClass: 'custom-sparepiece',
        next: 4
      }),
      positionFen: '8/1p3p2/p5p1/8/2p1p3/1p6/8/3n1B2 w - - 0 1',
    }
  },
  {
    id: 4,
    previous: 2,
    next: 5,
    video: {
      src: 'img/videos/lesson_5/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5,
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "How does the Bishop move?",
      answer: [
        'Across the ranks',
        'Up and down files',
        'On the diagonals',
        'Any direction he wants'
      ],
      rightAnswer: 'On the diagonals',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 6,
    previous: 4,
    next: 7,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "On which files do Bishops start of a game?",
      answer: [
        'A and H',
        'B and G',
        'F and C',
        'E and D'
      ],
      rightAnswer: 'F and C',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 7,
    previous: 4,
    next: 8,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: "What is the Bishop's symbol?",
      answer: [
        'p',
        'bi',
        'B',
        'He has no symbol'
      ],
      rightAnswer: 'B',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 8,
    previous: 4,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What is special about the Bishops?",
      answer: [
        'White Bishops stand on White squares, Black Bishops stand on Black squares',
        'They only travel on one color square the entire game',
        "They can jump over other pieces",
        'They can be promoted to King'
      ],
      rightAnswer: 'They only travel on one color square the entire game',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xl',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 9,
    previous: 4,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'How many points is the Bishop worth?',
      answer: [
        '1',
        '2',
        '3',
        '4'
      ],
      rightAnswer: '3',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 4,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'How do Bishops capture?',
      answer: [
        'On the diagonal',
        'By jumping over a pawn',
        'Along a file or rank',
        'By getting to the other side of the board'
      ],
      rightAnswer: 'On the diagonal',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 11,
    previous: 4,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'In the Middle Ages, Bishops...',
      answer: [
        'Were the first line of defense in battle',
        'Gave advice to the King and Queen',
        'Rode horseback into battle',
        'Lived in the castle as painters'
      ],
      rightAnswer: 'Gave advice to the King and Queen',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 4,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'What is unique about diagonal lines?',
      answer: [
        "You can't see them",
        'They alternate colors',
        'They are only one color',
        'They can get you to any square'
      ],
      rightAnswer: 'They are only one color',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 4,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the squares <br/>the Bishop could <br/>move to.`,
    },
    chessboard: {
      board: highlightCoordinates({
        id: 8,
        isQA: true,
        reminder :true,
        showIndicators: { allSides: true },
        celebrationSound: false,
        position: { c6: 'bB' },
        coordinates: ['.square-a4', '.square-a8', '.square-b5', '.square-b7', '.square-d5', '.square-d7', '.square-e4', '.square-e8', '.square-f3', '.square-g2', '.square-h1'],
        coordinateClass: 'filled-square',
        next: 14
      })
    }
  },
  {
    id: 14,
    previous: 4,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the Bishop <br/>could capture.`,
    },
    chessboard: {
      board: highlightCoordinates({
        id: 8,
        isQA: true,
        reminder: true,
        showIndicators: { allSides: true },
        celebrationSound : false,
        position: { b3: 'wP', b7: 'wR', d2: 'wR', d5: 'bB', d6: 'wP', f3: 'bP', g8: 'wN', h1: 'wN' },
        coordinates: ['.square-b3', '.square-b7', '.square-g8'],
        coordinateClass: 'filled-square',
        next: 15
      })
    }
  },
  {
    id: 15,
    previous: 4,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Six',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_4.png',
  '/img/background_5.png',
  '/img/background_6.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_5/index.js